import React, { Component } from 'react';
import {observer} from "mobx-react"
import EntreeStore from "../EntreeStore"
import Pdf from "./Pdf"
import axios from "axios"
import { HashRouter as Router, Route, Link } from "react-router-dom";

@observer
export default class Gestion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pdfKey: random(1000),
      validated: false
    };
  }
  validate(){
    axios.post("/api/v1/experts/app/entree/validateEntree",{id: EntreeStore.rdv.id}).then((data)=>{
      document.location.reload(true)
    })
  }
  componentDidMount(){
  }
  render() {
    if(EntreeStore.loaded){

      return(
        <div>
            <h1 className="center">Gestion de l'entrée</h1>
            <div className="row">
              <div className="col s12 m6">
                <h1>Valider l'entrée</h1>
                <p>Si vous avez terminé l'état des lieux, et que les textes sont complets <br/>
                  Après validation l'état des lieux est envoyé à tout les partis
                </p>
                <p onClick={this.validate} className="center btn-large btn">Valider</p>
              </div>
              <div className="col s12 m6">
                <a onClick={()=> this.setState({pdfKey: random(1000)})} className="btn-large"><i className="left material-icons">replay</i>Recharger</a>
                <Pdf key={this.state.pdfKey} pdf={"/experts/entree/generepdf/"+EntreeStore.rdv.id}/>
              </div>
            </div>
        </div>
        )
    }else{
     return (
        <div>
        Chargement en cours
        </div>
      );
   }
  }
}



const random = (max=100)=>{
  let val = Math.floor((Math.random() * max) + 1);
  return val;

}
